import "./UserDetails.scss"
import { FC, useState } from "react"
import { Button, Box, Typography } from "@mui/material"
import { useAppDispatch, useAppSelector } from "../../../redux/hooks"
import { ModalTypes, showModal } from "../../../redux/slices/modalSlice"
import { selectUserData, updateUserAsync } from "../../../redux/slices/authSlice"
import useFormValidation from "../../../hooks/useFormValidation"
import Loader from "../../Loader/Loader.component"
import { useTranslationLabel } from "../../../hooks/useTranslationLabel"
import AppInput from "../../AppInput/AppInput.component"
import { useValidationSchemas } from "../../../hooks/useIsValidationScehemes"
import { UserData } from "../../../types/userTypes"
import { RootState } from "../../../redux/store"

export type UserDetailsProps = {
  street: string
  city: string
  phone: string
  email: string
  displayPassowrdUpdate?: boolean
}

const UserDetails: FC<UserDetailsProps> = ({ street, city, phone, email, displayPassowrdUpdate }) => {
  const dispatch = useAppDispatch()
  const [editMode, setEditMode] = useState(false)
  const [loading, setLoading] = useState(false)
  const { userDetailsSchema } = useValidationSchemas()
  const { formData, errors, handleChange, validateField, validateForm } =
    useFormValidation({ street, city }, userDetailsSchema)
  const {
    USER_DETAILS_TITLE,
    USER_DETAILS_EDIT_BTN,
    USER_DETAILS_SAVE_BTN,
    LOGIN_DETAILS_TITLE,
    LOGIN_DETAILS_EMAIL,
    LOGIN_DETAILS_PASSWORD,
    LOGIN_DETAILS_PIN,
    USER_DETAILS_UPDATE_PASSWORD,
    INPUT_STREET_AND_HOUSE_NUM,
    INPUT_CITY,
    INPUT_PHONE,
    USER_DETAILS_UPDATE_PINCODE
  } = useTranslationLabel()
  const userData: UserData | null = useAppSelector(selectUserData)
  const handleEdit = async () => {
    if (editMode && validateForm()) {

      console.log("formData", formData)
      setLoading(true)
      await dispatch(updateUserAsync(formData))
        .unwrap()
        .then(() => { })
        .catch((err) => {
          alert("Something went wrong!")
        })
        .finally(() => {
          setLoading(false)
        })
      setEditMode(false)
    } else {
      setEditMode(true)
    }
  }

  return (
    <Box className="user-details-container">
      {loading && <Loader />}
      <Box className="personal-details">
        <div className="top-section full space-between">
          <Typography variant="h4" className="title">
            {USER_DETAILS_TITLE}
          </Typography>

          <Button
            className="primary-btn sm editButton"
            variant="contained"
            onClick={handleEdit}
          >
            {editMode ? USER_DETAILS_SAVE_BTN : USER_DETAILS_EDIT_BTN}
          </Button>
        </div>

        <AppInput
          label={INPUT_STREET_AND_HOUSE_NUM}
          name="street"
          value={formData.street}
          disabled={!editMode}
          error={errors.street}
          onChange={handleChange}
          onBlur={() => validateField("street", formData.street)}
        />

        <AppInput
          label={INPUT_CITY}
          name="city"
          value={formData.city}
          disabled={!editMode}
          error={errors.city}
          onChange={handleChange}
          onBlur={() => validateField("city", formData.city)}
        />

        {/* <AppInput
          label={INPUT_POSTAL_CODE}
          name="postalCode"
          disabled={!editMode}
          value={formData.postalCode}
          error={errors.postalCode}
          onChange={handleChange}
          onBlur={() => validateField("postalCode", formData.postalCode)}
        /> */}

        {!editMode && (
          <AppInput
            label={INPUT_PHONE}
            name="phoneText"
            disabled={!editMode}
            value={phone}
            error={errors.postalCode}
          />
        )}
      </Box>
      <Box className="login-details">
        <Typography variant="h4" className="title">
          {LOGIN_DETAILS_TITLE}
        </Typography>
        <Typography variant="body1" className="body1">
          {LOGIN_DETAILS_EMAIL}: {email}
        </Typography>
        <Typography variant="body1" className="body1">
          {LOGIN_DETAILS_PASSWORD}: *******
        </Typography>
        {userData?.drivingSettings?.pincode &&<Typography variant="body1" className="body1">
          {LOGIN_DETAILS_PIN}: ****
        </Typography>}

        <div className="modal-btns-container flex">
          {editMode && displayPassowrdUpdate && (

            <Button
              className="primary-btn passwordButton"
              variant="contained"
              color="secondary"
              onClick={() =>
                dispatch(
                  showModal({ activeModal: ModalTypes.CHANGE_PASSWORD_MODAL }),
                )
              }
            >
              {USER_DETAILS_UPDATE_PASSWORD}
            </Button>
          )}
          {/* WIP */}
          {editMode && userData?.drivingSettings?.pincode && <Button
            className="primary-btn pinCodeButton"
            variant="contained"
            onClick={() =>
              dispatch(
                showModal({ activeModal: ModalTypes.CHANGE_PIN_CODE_MODAL }),
              )
            }
          >
            {USER_DETAILS_UPDATE_PINCODE}
          </Button>}
        </div>

      </Box>
    </Box>
  )
}

export default UserDetails
